export interface RestaurantSocialLinks {
  zomatoUrl?: string;
  zomatoRating?: number;
  swiggyUrl?: string;
  swiggyRating?: number;
  googleReviewsUrl?: string;
  googleReviewsRating?: number;
  instagramUrl?: string;
  twitterUrl?: string;
  facebookUrl?: string;
  youtubeUrl?: string;
}

export interface SocialLinkItem {
  key: string;
  label: string;
  url: string;
  icon: string;
  rating?: number;
}

export interface PlatformReviewItem {
  key: string;
  label: string;
  url: string;
  rating?: number;
  brandClass: string;
}

const hasText = (value?: string | null): value is string =>
  typeof value === 'string' && value.trim().length > 0;

export const hasSocialLinks = (links?: RestaurantSocialLinks | null): boolean => {
  if (!links) return false;
  return (
    hasText(links.zomatoUrl) ||
    hasText(links.swiggyUrl) ||
    hasText(links.googleReviewsUrl) ||
    hasText(links.instagramUrl) ||
    hasText(links.twitterUrl) ||
    hasText(links.facebookUrl) ||
    hasText(links.youtubeUrl)
  );
};

export const getPlatformReviewLinks = (links?: RestaurantSocialLinks | null): PlatformReviewItem[] => {
  if (!links) return [];
  const items: PlatformReviewItem[] = [];
  if (hasText(links.zomatoUrl)) {
    items.push({
      key: 'zomato',
      label: 'Zomato',
      url: links.zomatoUrl.trim(),
      rating: links.zomatoRating,
      brandClass: 'rd-platform--zomato',
    });
  }
  if (hasText(links.swiggyUrl)) {
    items.push({
      key: 'swiggy',
      label: 'Swiggy',
      url: links.swiggyUrl.trim(),
      rating: links.swiggyRating,
      brandClass: 'rd-platform--swiggy',
    });
  }
  if (hasText(links.googleReviewsUrl)) {
    items.push({
      key: 'google',
      label: 'Google Reviews',
      url: links.googleReviewsUrl.trim(),
      rating: links.googleReviewsRating,
      brandClass: 'rd-platform--google',
    });
  }
  return items;
};

export const getSocialMediaLinks = (links?: RestaurantSocialLinks | null): SocialLinkItem[] => {
  if (!links) return [];
  const items: SocialLinkItem[] = [];
  if (hasText(links.instagramUrl)) {
    items.push({ key: 'instagram', label: 'Instagram', url: links.instagramUrl.trim(), icon: 'instagram' });
  }
  if (hasText(links.twitterUrl)) {
    items.push({ key: 'twitter', label: 'X (Twitter)', url: links.twitterUrl.trim(), icon: 'twitter' });
  }
  if (hasText(links.facebookUrl)) {
    items.push({ key: 'facebook', label: 'Facebook', url: links.facebookUrl.trim(), icon: 'facebook' });
  }
  if (hasText(links.youtubeUrl)) {
    items.push({ key: 'youtube', label: 'YouTube', url: links.youtubeUrl.trim(), icon: 'youtube-play' });
  }
  return items;
};
